import { FC, useState } from "react";

import {
  VpdAttributesWrapper,
  VpdReferenceSiteWrapper,
} from "../../components";
import { CampaignCommonProps } from "../types";
import { Campaign } from "@vviinn/user-managment-client-ts";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { colorNumericSettings, controlledInputTitles } from "../../constants";
import { SubSectionWithStyles } from "../../../ui/layout";
import { parseNumberOrZero } from "../../../helpers";

type VPDCampaignProps = {
  siteId: number;
  companyId: string;
};

export const AdvancedVPDSettings: FC<
  CampaignCommonProps & VPDCampaignProps
> = ({ currentValues, updateBodyField, siteId, companyId }) => {
  const [referenceCompanyId, setReferenceCompanyId] =
    useState<Campaign["referenceCompanyId"]>(companyId);
  const [referenceSiteId, setReferenceSiteId] =
    useState<Campaign["referenceSiteId"]>();

  const handleReferenceCompany = (newValue?: string) => {
    setReferenceCompanyId(newValue);
    updateBodyField({
      referenceCompanyId: newValue,
    });
  };

  const handleReferenceSite = (newValue?: number) => {
    setReferenceSiteId(newValue);
    updateBodyField({
      referenceSiteId: newValue,
    });
  };

  return (
    <>
      <SubSectionWithStyles title="Reference catalog" isSubHeader={false}>
        <VpdReferenceSiteWrapper
          selectedSiteId={referenceSiteId}
          setSelectedSiteId={handleReferenceSite}
          selectedCompanyId={referenceCompanyId}
          setSelectedCompanyId={handleReferenceCompany}
          active={!!referenceSiteId}
          toggleFields={(value) => {
            handleReferenceSite(value ? siteId : undefined);
            handleReferenceCompany(value ? companyId : undefined);
          }}
          styleVariant="newPage"
        />
      </SubSectionWithStyles>
      <SubSectionWithStyles
        title="Attribute prediction"
        isSubHeader={false}
        withGroup={false}
        className=""
      >
        <VpdAttributesWrapper
          productAttributes={currentValues.productAttributes}
          setProductAttributes={(newValue) =>
            updateBodyField({ productAttributes: newValue })
          }
          imageAttributes={currentValues.imageAttributes}
          setImageAttributes={(newValue) =>
            updateBodyField({ imageAttributes: newValue })
          }
          isNewPage={true}
        />
      </SubSectionWithStyles>
      <SubSectionWithStyles title="Color" isSubHeader={false}>
        {currentValues &&
          colorNumericSettings.map((key) => (
            <NamedNumberic
              title={controlledInputTitles[key]}
              key={key}
              value={currentValues[key]}
              onChange={(target) =>
                updateBodyField({ [key]: parseNumberOrZero(target.value) })
              }
            />
          ))}
      </SubSectionWithStyles>
    </>
  );
};
